import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // 使用 useNavigate 代替 useHistory
import axios from 'axios';

function Schedule1() {
  const [schedules, setSchedules] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'time', direction: 'asc' });
  const [teamFilter, setTeamFilter] = useState('');
  const [editingStatusId, setEditingStatusId] = useState(null);
  const [statusOptions] = useState(['未開始', '進行中', '已結束']);
  const navigate = useNavigate(); // 使用 useNavigate

  useEffect(() => {
    const fetchSchedules = async () => {
      try {
        const response = await axios.get('/api/schedules');
        setSchedules(response.data);
      } catch (error) {
        console.error('Error fetching schedules:', error);
      }
    };

    fetchSchedules();
  }, []);

  const handleStatusChange = async (scheduleId, newStatus) => {
    try {
      // 更新本地狀態以立即反映更改
      setSchedules((prevSchedules) =>
        prevSchedules.map((schedule) =>
          schedule._id === scheduleId ? { ...schedule, status: newStatus } : schedule
        )
      );
  
      // 發送 PUT 請求到後端 API
      await axios.put(`/api/schedules/${scheduleId}`, { status: newStatus });
  
      setEditingStatusId(null); // 重置編輯狀態
    } catch (error) {
      console.error('Error updating status:', error);
      alert('更新狀態時出錯，請稍後重試！');
    }
  };

  // 切換狀態至下一個選項
  const handleToggleStatus = (scheduleId) => {
    const schedule = schedules.find((s) => s._id === scheduleId);
    if (!schedule) return;
    const currentIdx = statusOptions.indexOf(schedule.status);
    const nextStatus = statusOptions[(currentIdx + 1) % statusOptions.length];
    handleStatusChange(scheduleId, nextStatus);
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      await axios.delete(`/api/schedules/${scheduleId}`);
      setSchedules((prevSchedules) => prevSchedules.filter(schedule => schedule._id !== scheduleId));
    } catch (error) {
      console.error('Error deleting schedule:', error);
    }
  };

  const handleAddSchedule = () => {
    navigate('/add-schedule'); // 使用 useNavigate 來進行導航
  };

  const sortedSchedules = React.useMemo(() => {
    let sortableSchedules = [...schedules];

    if (teamFilter) {
      sortableSchedules = sortableSchedules.filter(schedule => {
        const team1Info = `${schedule.teams[0].teamName} ${schedule.teams[0].players.map(player => player.name).join(' ')}`;
        const team2Info = `${schedule.teams[1].teamName} ${schedule.teams[1].players.map(player => player.name).join(' ')}`;
        return team1Info.includes(teamFilter) || team2Info.includes(teamFilter);
      });
    }

    if (sortConfig !== null) {
      sortableSchedules.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableSchedules;
  }, [schedules, sortConfig, teamFilter]);

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

   // 發送下一場比賽通知的函數
   const handleSendNextMatchNotification = async () => {
    try {
      // 發送 POST 請求到後端 API
      const response = await axios.post('/api/notify-upcoming-matches');
      console.log('Notification sent:', response.data);
      alert('已成功發送下一場比賽通知！');
    } catch (error) {
      console.error('Error sending notification:', error);
      alert('發送通知時發生錯誤！');
    }
  };


  return (
    <div >
      <div>
        <h3 className="text-center">賽程表</h3>
        <button onClick={handleAddSchedule} className="btn btn-success">
          新增
        </button>
         {/* 新增發送通知的按鈕 */}
         <button onClick={handleSendNextMatchNotification} className="btn btn-warning ms-2">
          發送下一場比賽通知
        </button>
      </div>

      <div className="mb-3">
        <input
          type="text"
          placeholder="篩選組別或參賽者"
          value={teamFilter}
          onChange={(e) => setTeamFilter(e.target.value)}
          className="form-control"
        />
      </div>

      <table className="table table-striped table-dark">
        <thead>
          <tr>
            <th onClick={() => requestSort('date')}>日期</th>
            <th onClick={() => requestSort('time')}>時間</th>
            <th onClick={() => requestSort('court')}>場地</th>
            <th onClick={() => requestSort('status')}>狀態</th>
            <th onClick={() => requestSort('team1')}>隊伍 1</th>
            <th onClick={() => requestSort('team2')}>隊伍 2</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {sortedSchedules.map((schedule) => (
            <tr key={schedule._id}>
              <td>{schedule.date}</td>
              <td>{schedule.time}</td>
              <td>{schedule.court}</td>
              <td>
                {editingStatusId === schedule._id ? (
                  <select
                    value={schedule.status}
                    onChange={(e) => handleStatusChange(schedule._id, e.target.value)}
                    onBlur={() => setEditingStatusId(null)}
                    className="form-select"
                  >
                    {statusOptions.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                ) : (
                  <span onClick={() => setEditingStatusId(schedule._id)} style={{ cursor: 'pointer' }}>
                    {schedule.status}
                  </span>
                )}
              </td>
              <td>
                {schedule.teams[0].teamName}
                <br />
                {schedule.teams[0].players.map((player) => player.name).join(', ')}
              </td>
              <td>
                {schedule.teams[1].teamName}
                <br />
                {schedule.teams[1].players.map((player) => player.name).join(', ')}
              </td>
              {/* 操作欄位 */}
              <td className="d-flex align-items-center">
                {/* 切換狀態按鈕 */}
                <button
                  onClick={() => handleToggleStatus(schedule._id)}
                  className="btn btn-secondary btn-sm me-2"
                >
                  切換狀態
                </button>
                <Link
                  to={`/edit-schedule/${schedule._id}`}
                  className="btn btn-primary btn-sm ms-2"
                >
                  編輯
                </Link>
                <button
                  onClick={() => handleDeleteSchedule(schedule._id)}
                  className="btn btn-danger btn-sm ms-2"
                >
                  刪除
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Schedule1;
